import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from '../../../button/button.module';
import { InputBoxModule } from '../../../input-box/input-box.module';
import { SelectBoxModule } from '../../../select-box/select-box.module';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';

import { NotesComponent } from './notes.component';
import { IconicModule } from '../../../iconic/iconic.module';

import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';
import { LoadingPanelModule } from '../../../loading-panel/loading-panel.module';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { InputColorBoxModule } from '../../../input-color-box/input-color-box.module';
import { RangeSliderModule } from '../../../range-slider/range-slider.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    InputBoxModule,
    InputColorBoxModule,
    SelectBoxModule,
    TooltipModule,
    MatInputModule,
    IconicModule,
    ScrollViewModule,
    LoadingPanelModule,
    BlockModalDragModule,
    RangeSliderModule
  ],
  declarations: [NotesComponent],
  exports: [NotesComponent],
})
export class NotesModule { }
